module.exports = __webpack_public_path__ + "img/bg_selecte.8cd6230d.png";